/* eslint-disable */
export const Genders = {
    MALE: "male",
    FEMALE: "female",
}
